import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as THREE from "three";
import Experience from "../Experience";
import Resources from "../utils/Resources";
import { CoolS2D } from "./CoolS2D";
import { CoolS3D } from "./CoolS3D";
import Environment from "./Environment";
import SceneDirector from "./SceneDirector";

gsap.registerPlugin(ScrollTrigger);

export default class World {
  experience: Experience;
  scene: THREE.Scene;
  resources: Resources;
  environment: Environment | undefined;
  sectionsRoot: HTMLElement;
  sections: HTMLElement[];
  coolS2D?: CoolS2D;
  coolS3D?: CoolS3D;
  sceneDirector?: SceneDirector;

  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.sectionsRoot = this.experience.sectionsRoot;
    this.sections = Array.from(this.sectionsRoot.children) as HTMLElement[];

    this.resources.on("ready", () => {
      // Setup
      this.coolS2D = new CoolS2D();
      this.coolS3D = new CoolS3D();
      this.sceneDirector = new SceneDirector(
        this.coolS2D,
        this.coolS3D,
        this.sections
      );
      this.environment = new Environment();
    });
  }

  update() {
    const delta = this.experience.time.delta;
    this.sceneDirector?.update(delta);
  }

  resize() {
    this.coolS2D?.resize();
    this.coolS3D?.resize();
    ScrollTrigger.refresh();
  }
}
